import Loader from "./newLoader";
interface Props {
  primary?: boolean;
  primaryReverse?: boolean;
}
const GeneralApiLoader: React.FC<Props> = ({}) => {
  return (
    <div className="lottie-box">
      <div className="no-shipping-methods height-200">
        <Loader />
      </div>
    </div>
  );
};

export default GeneralApiLoader;
